/* Indeedsooo Theme JS */
(function() {
  'use strict';

  /* Header scroll effect */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    });
  }

  /* Nav dropdowns + mega menus */
  document.querySelectorAll('.header__nav-item').forEach(function(item) {
    var link = item.querySelector('.header__nav-link');
    var dropdown = item.querySelector('[data-dropdown]');
    if (!dropdown) return;

    link.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('[data-dropdown].is-open').forEach(function(d) {
        if (d !== dropdown) d.classList.remove('is-open');
      });
      dropdown.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.header__nav-item')) {
      document.querySelectorAll('[data-dropdown].is-open').forEach(function(d) {
        d.classList.remove('is-open');
      });
    }
  });

  /* Mobile menu toggle */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function() {
      nav.classList.toggle('is-mobile-open');
    });
  }

  /* Search toggle */
  var searchToggle = document.querySelector('[data-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener('click', function() {
      var parent = searchToggle.closest('.header__search');
      var existing = parent.querySelector('.header__search-input');
      if (existing) {
        existing.remove();
        var closeBtn = parent.querySelector('.header__search-close');
        if (closeBtn) closeBtn.remove();
        searchToggle.style.display = '';
        return;
      }
      searchToggle.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'header__search-input';
      input.placeholder = 'Search...';
      input.setAttribute('name', 'q');

      var form = document.createElement('form');
      form.action = '/search';
      form.method = 'get';
      form.style.display = 'flex';
      form.style.alignItems = 'center';
      form.style.gap = '8px';
      form.appendChild(input);

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'header__search-close';
      close.innerHTML = '&times;';
      close.addEventListener('click', function() {
        form.remove();
        searchToggle.style.display = '';
      });
      form.appendChild(close);
      parent.appendChild(form);
      input.focus();
    });
  }
})();
